// import React, { useState, useRef, useEffect } from "react";
// import "./productcart.css";
// import up from '../../assets/up.svg';
// import { Helmet } from 'react-helmet';
// import down from '../../assets/down.svg';
// // import starIcon from '../../assets/star.png';
// import brandLogo from '../../assets/brand.png';
// // import { AiFillStar, AiOutlineStar } from "react-icons/ai";
// import ReactStars from "react-rating-stars-component";
// import { useSwipeable } from 'react-swipeable';
// import {addToCart,removeFromCart, setCart,  setTotalItems,setTotalPrice,setCartId,} from "../../store/cartSlice";
// import ProductDetails from '../description/description';
// import cartIcon from '../../assets/addcart.png';
// import { FaFacebookF, FaTwitter, FaPinterestP, FaInstagram } from "react-icons/fa";
// import { FaHeart, FaRegHeart } from 'react-icons/fa';
// import { useDispatch, useSelector } from 'react-redux';
// import { postWithTokenAPI } from '../../util/Api';
// import { useLocation } from 'react-router-dom';
// import { productParticular } from '../../util/Api';
// import RelatedProductsmy from '../related/Final-related';
// import LoginPopup from "../../Components/Loginpopup/Loginpop";
// import {toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { showToastSuccessMsg, showToastErrorMsg } from '../../store/toastMsg';
// import { incrementWishlistCount, decrementWishlistCount, addToWishlist, removeFromWishlist } from '../../store/wishlistSlice';
// import { FaArrowLeft } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';
// import DOMPurify from 'dompurify';


// const ProductCard = ({ product }) => {
//   const [quantity, setQuantity] = useState(1);
//   const [activeImageIndex, setActiveImageIndex] = useState(0);
//   const [productData, setProductData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const thumbnailRef = useRef(null);
//   const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);
//   const dispatch = useDispatch();
//   const [addingToCart, setAddingToCart] = useState(false);
//   // const [cartSuccessMessage, setCartSuccessMessage] = useState('');


//   // State for mobile view
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

//   const accessToken = useSelector((state) => state.auth?.auth?.access_token);
//   const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);
//   const userId = useSelector((state) => state.auth?.auth?.user_id);
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const productId = queryParams.get('_id');
//   const wishStatus = queryParams.get('wish_status');
//     const [isInWishlist, setIsInWishlist] = useState(productData?.wish_status || false);
  
//     const cleanHTML = DOMPurify.sanitize(productData?.short_description, {
//       ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a', 'b', 'i'],
//       ALLOWED_ATTR: ['href', 'target', 'rel']
//     });
//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         setLoading(true);

//         if (product) {
//           setProductData(product);
//           setIsInWishlist(product.wish_status || false);
//           return;
//         }

//         if (!productId) {
//           throw new Error('No product ID found');
//         }

//         const queryParamsid = (userId && typeof userId === 'string' && userId.length === 24) ? `&user_id=${userId}` : '';
//         const response = await productParticular(`/product/find-particular?_id=${productId}${queryParamsid}`);
        
//         if (response?.statusCode === 200) {
//           setProductData(response.data);
//           // Set wishlist status from URL first, then fallback to API response
//           if (wishStatus !== null) {
//             setIsInWishlist(wishStatus === 'true');
//           } else {
//             setIsInWishlist(response.data.wish_status || false);
//           }
//         } else {
//           throw new Error('Product not found');
//         }
//       } catch (error) {
//         console.error('Error fetching product:', error);
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProduct();
//   }, [product, productId, wishStatus, userId]);

//   // Effect for handling window resize
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobileView(window.innerWidth < 768);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const productImages = productData?.product_image || [];
//   const sellerName = productData?.seller_id?.name || "Unknown Seller";

//   const decreaseQuantity = () => quantity > 1 && setQuantity(quantity - 1);
//   const increaseQuantity = () => setQuantity(quantity + 1);

//   const scrollUp = () => thumbnailRef.current?.scrollBy({ top: -100, behavior: 'smooth' });
//   const scrollDown = () => thumbnailRef.current?.scrollBy({ top: 100, behavior: 'smooth' });

//   // Swipe handlers for mobile carousel
//   const handleSwipedLeft = () => {
//     setActiveImageIndex((prevIndex) => (prevIndex + 1) % productImages.length);
//   };

//   const handleSwipedRight = () => {
//     setActiveImageIndex((prevIndex) => (prevIndex - 1 + productImages.length) % productImages.length);
//   };

//   const swipeHandlers = useSwipeable({
//     onSwipedLeft: handleSwipedLeft,
//     onSwipedRight: handleSwipedRight,
//     preventScrollOnSwipe: true,
//     trackMouse: true
//   });


//   const handleWishlistClick = async (e) => {
//     e.stopPropagation();
    
//     if (!isLoggedIn || !accessToken) {
//       navigate('/login');
//       return;
//     }

//     try {
//       const payload = {
//         product_id: productData._id,
//         category_id: productData.category_id?._id || productData.category_id,
//       };

//       const response = await postWithTokenAPI(accessToken, "/wishlist/add", payload);

//       if (response?.statusCode === 200) {
//         // Update both local state and productDetails
//         setIsInWishlist(true);
//         dispatch(addToWishlist(productData));
//         dispatch(incrementWishlistCount());
//         toast.success('Item added to wishlist successfully!');
//       } else if (response?.statusCode === 406) {
//         // Update both local state and productDetails
//         setIsInWishlist(false);
//         dispatch(removeFromWishlist(productData._id));
//         dispatch(decrementWishlistCount());
//         toast.success('Item removed from wishlist');
//       } else {
//         console.warn("Failed to update wishlist:", response);
//         toast.error('Failed to update wishlist');
//       }
//     } catch (error) {
//       console.error("Error updating wishlist:", error);
//       toast.error('Error updating wishlist');
//     }
//   };

// const handleAddToCart = async (cartItem) => {
//   if (!accessToken) {
//     setLoginPopupOpen(true);
//     return;
//   }
//   if (!cartItem?._id) return;

//   if (addingToCart) return;
//   setAddingToCart(true);
//   setError(null);

//   try {
//     const payload = {
//       cart: [
//         {
//           product_id: cartItem._id,
//           quantity: cartItem.quantity > 0 ? cartItem.quantity : 1,
//         },
//       ],
//     };

//     const response = await postWithTokenAPI(accessToken, "/cart/add", payload);

//     // 🧹 Case: Cart emptied
//     if (
//       response?.statusCode === 200 &&
//       response?.message === "Product removed and cart deleted as it became empty"
//     ) {
//       dispatch(setCart([]));
//       dispatch(setTotalItems(0));
//       dispatch(setTotalPrice(0));
//       dispatch(setCartId(null));
//       toast.info("Item removed and cart is now empty.", {
//         position: "top-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         toastId: `removed-${cartItem._id}`,
//         theme: "light",
//       });
//     }

//     // ✅ Case: Product added successfully
//     else if (response?.statusCode === 200 && response.data?.cart) {
//       const addedItem = response.data.cart;

//       dispatch(
//         addToCart({
//           id: addedItem.product_id,
//           price: addedItem.price,
//           quantity: addedItem.quantity,
//           name: addedItem.name,
//           image: addedItem.image,
//         })
//       );

//       toast.success("Item added to cart successfully!", {
//         position: "top-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         toastId: `cart-${cartItem._id}`,
//         theme: "light",
//       });
//     }

//     // ❌ Failure case
//     else {
//       toast.error("Failed to add item to cart.", {
//         position: "top-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         toastId: `error-${cartItem._id}`,
//         theme: "light",
//       });
//     }
//   } catch (error) {
//     console.error("Add to cart error:", error);
//     toast.error("Something went wrong. Please try again.", {
//       position: "top-right",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       toastId: `error-${cartItem._id}`,
//       theme: "light",
//     });
//   } finally {
//     setAddingToCart(false);
//   }
// };

//   const closeLoginPopup = () => {
//     setLoginPopupOpen(false);
//   };

//   if (loading) return <div className="loading-message">Loading product...</div>;
//   if (error) return <div className="error-message">Error: {error}</div>;
//   if (!productData) return <div className="error-message">Product not found</div>;

//   const starRatingConfig = {
//     size: 20,
//     value: productData.average_rating || 0,
//     edit: false,
//     activeColor: "#ffd700",
//     color: "#d4d4d4",
//     isHalf: true,
//     count: 5,
//     a11y: true,
//     onChange: () => {},
//     classNames: {
//       container: "star-rating-container",
//       star: "star-rating-star"
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <Helmet>
//         <title>{productData.name ? `${productData.name}'s Product` : 'Product'}</title>
//         < meta name="description" content="Specific Product page" />
//       </Helmet>
//       {isLoginPopupOpen && <LoginPopup onClose={closeLoginPopup} />}

//       <div className='product-containers'>
//         {/* Product Image Gallery / Carousel */}
//         {isMobileView ? (
         
//           <div className="mobile-image-carousel">
//              <div className="button-back-mobile" onClick={() => navigate('/shop')}>
//           <FaArrowLeft className="back-icon" />
//           <button className="back-text">back</button>
//         </div> 
//             <div {...swipeHandlers} className="carousel-images" style={{ transform: `translateX(-${activeImageIndex * 100}%)` }}>
//               {productImages.map((image, index) => (
//                 <img
//                   key={index}
//                   src={image}
//                   className="carousel-image-item"
//                   alt={`Product view ${index + 1}`}
//                 />
//               ))}
//             </div>
//             {productImages.length > 1 && (
//               <div className="carousel-dots">
//                 {productImages.map((_, index) => (
//                   <span
//                     key={index}
//                     className={`dot ${index === activeImageIndex ? 'active' : ''}`}
//                     onClick={() => setActiveImageIndex(index)}
//                   ></span>
//                 ))}
//               </div>
//             )}
//           </div>
//         ) : (
//           <div className="product-image-container">
//             <div className="side-image">
//               <button className="nav-arrow up" onClick={scrollUp}>
//                 <img src={up} alt="Scroll up" />
//               </button>
//               <div className="show-image" ref={thumbnailRef}>
//                 {productImages.map((image, index) => (
//                   <img
//                     key={index}
//                     src={image}
//                     className={`select-image ${index === activeImageIndex ? 'active' : ''}`}
//                     onClick={() => setActiveImageIndex(index)}
//                     alt={`Thumbnail ${index + 1}`}
//                   />
//                 ))}
//               </div>
//               <button className="nav-arrow down" onClick={scrollDown}>
//                 <img src={down} alt="Scroll down" />
//               </button>
//             </div>

//             <div className="main-product-container">
//               <img
//                 src={productImages[activeImageIndex]}
//                 className="main-product"
//                 alt="Main product view"
//               />
//             </div>
//           </div>
//         )}

//         {/* Product Details */}
//         <div className='product-detail-box'>
//           <div className="product-header">
//             <div className="product-title-row">
//               <h1 className="product-titles">{productData.name}</h1>
//               {isMobileView && (
//                 <button
//                   className={`wish-btn mobile-wish-btn ${isInWishlist ? 'wishlist-active' : ''}`}
//                   onClick={handleWishlistClick}
//                   aria-label="Toggle Wishlist"
//                 >
//                   {isInWishlist ? (
//                     <FaHeart style={{ color: '#CC0000' }} />
//                   ) : (
//                     <FaRegHeart style={{ color: '#1a1a1a' }} />
//                   )}
//                 </button>
//               )}
//               {/* <div className="stocks-status">In Stock</div> */}
//             </div>
//             <span
//               className="ff-poppins fs-12"
//               style={{ color: "#CC0000" }}
//             >
//               {sellerName}
//             </span>
//             <div className="rating-sku">
//               <div className="rating">
//                 <ReactStars
//                   {...starRatingConfig}
//                   key={`stars-${productData.average_rating}`}
//                 />
//               </div>
//               <span className="review-count">{productData.average_rating || 0} rating</span>
//               {/* <span className="dot">•</span>
//               <div className="sku">
//                 <span>SKU:</span>
//                 <span className="num">{productData.sku || 'N/A'}</span>
//               </div> */}
//             </div>
//           </div>

//           <div className="price-section">
//             <div className="price-row-product">
//               {productData.original_price && (
//                 <span className="original-price">Ksh {productData.original_price.toFixed(2)}</span>
//               )}
//               <span className="current-price">Ksh {productData.discount_price.toFixed(2)}</span>
//               {productData.original_price && (
//                 <div className="discount-badge">
//                   {Math.round(100 - (productData.discount_price / productData.original_price) * 100)}% Off
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="dividers"></div>

//           <div className="brand-section">
//             <div className="brand-header">
//               {/* <span className="brand-label">Brand:</span> */}
//               {/* <div className="brand-logo-container">
//                 <img src={brandLogo} alt="brand" className="brand-logo" />
//               </div> */}

//               <div className="share-section-product">
//                 <span>Share item:</span>
//                 <div className="social-icon-product">
//                   <a href="https://www.facebook.com/" aria-label="Facebook"><FaFacebookF /></a>
//                   <a href="https://x.com/?lang=en" aria-label="Twitter"><FaTwitter /></a>
//                   <a href="https://in.pinterest.com/" aria-label="Pinterest"><FaPinterestP /></a>
//                   <a href="https://www.instagram.com/" aria-label="Instagram"><FaInstagram /></a>
//                 </div>
//               </div>
//             </div>

//             <p className="brand-description">
//               {/* {productData.short_description || 'No description available.'} */}  
//               <div
//             className="brand-description"
//             dangerouslySetInnerHTML={{ __html: cleanHTML }}
//           />
//             </p>
//           </div>

//           <div className="dividers"></div>

//           <div className="cta-section">
//             {!isMobileView && (
//               <div className="quantity-selectors">
//                 <button className="quantity-btn minus" onClick={decreaseQuantity}>-</button>
//                 <span className="quantity">{quantity}</span>
//                 <button className="quantity-btn plus" onClick={increaseQuantity}>+</button>
//               </div>
//             )}

//             <button className="add-to-cart" onClick={() => handleAddToCart({ ...productData, quantity: isMobileView ? 1 : quantity })}>
//               Add to Cart
//               <img src={cartIcon} alt="cart" />
//             </button>

          
//               <button
//                 className={`wish-btn ${isInWishlist ? 'wishlist-active' : ''}`}
//                 onClick={handleWishlistClick}
//               >
//                 {isInWishlist ? (
//                   <FaHeart style={{ color: '#CC0000', fontSize: '16px' }} />
//                 ) : (
//                   <FaRegHeart style={{ color: '#1a1a1a', fontSize: '16px' }} />
//                 )}
//               </button>
           
//           </div>

//           <div className="category-tags">
//             <div className="category">
//               <span>Category:</span>
//               <span>{productData.category_id.category_name || 'General'}</span>
//             </div>

//             <div className="tags">
//               <span>Tag:</span>
//               {(productData.tag || ['Healthy']).map((tags, i) => (
//                 <span key={i}>{tags}</span>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div >

//       <ProductDetails productData={productData} />
//       <RelatedProductsmy />
//     </>
//   );
// };

// export default ProductCard;



"use client"

import { useState, useRef, useEffect } from "react"
import "./productcart.css"
import up from "../../assets/up.svg"
import { Helmet } from "react-helmet"
import down from "../../assets/down.svg"
// import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import ReactStars from "react-rating-stars-component"
import { useSwipeable } from "react-swipeable"
import { addToCart, setCart, setTotalItems, setTotalPrice, setCartId } from "../../store/cartSlice"
import ProductDetails from "../description/description"
import cartIcon from "../../assets/addcart.png"
import { FaFacebookF, FaTwitter, FaPinterestP, FaInstagram } from "react-icons/fa"
import { FaHeart, FaRegHeart } from "react-icons/fa"
import { useDispatch, useSelector } from "react-redux"
import { postWithTokenAPI } from "../../util/Api"
import { useLocation } from "react-router-dom"
import { productParticular } from "../../util/Api"
import RelatedProductsmy from "../related/Final-related"
import LoginPopup from "../../Components/Loginpopup/Loginpop"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {
  incrementWishlistCount,
  decrementWishlistCount,
  addToWishlist,
  removeFromWishlist,
} from "../../store/wishlistSlice"
import { FaArrowLeft } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import DOMPurify from "dompurify"

const ProductCard = ({ product }) => {
  const [quantity, setQuantity] = useState(1)
  const [activeImageIndex, setActiveImageIndex] = useState(0)
  const [productData, setProductData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const thumbnailRef = useRef(null)
  const [isLoginPopupOpen, setLoginPopupOpen] = useState(false)
  const dispatch = useDispatch()
  const [addingToCart, setAddingToCart] = useState(false)
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768)
  const accessToken = useSelector((state) => state.auth?.auth?.access_token)
  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn)
  const userId = useSelector((state) => state.auth?.auth?.user_id)
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const productId = queryParams.get("_id")
  const wishStatus = queryParams.get("wish_status")

  const [isInWishlist, setIsInWishlist] = useState(productData?.wish_status || false)

  const cleanHTML = DOMPurify.sanitize(productData?.short_description, {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "ul", "ol", "li", "a", "b", "i"],
    ALLOWED_ATTR: ["href", "target", "rel"],
  })

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true)
        if (product) {
          setProductData(product)
          setIsInWishlist(product.wish_status || false)
          return
        }
        if (!productId) {
          throw new Error("No product ID found")
        }
        const queryParamsid = userId && typeof userId === "string" && userId.length === 24 ? `&user_id=${userId}` : ""
        const response = await productParticular(`/product/find-particular?_id=${productId}${queryParamsid}`)

        if (response?.statusCode === 200) {
          setProductData(response.data)
          if (wishStatus !== null) {
            setIsInWishlist(wishStatus === "true")
          } else {
            setIsInWishlist(response.data.wish_status || false)
          }
        } else {
          throw new Error("Product not found")
        }
      } catch (error) {
        console.error("Error fetching product:", error)
        setError(error.message)
      } finally {
        setLoading(false)
      }
    }
    fetchProduct()
  }, [product, productId, wishStatus, userId])

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768)
    }
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const productImages = productData?.product_image || []
  const sellerName = productData?.seller_id?.name || "Unknown Seller"
  const decreaseQuantity = () => quantity > 1 && setQuantity(quantity - 1)
  const increaseQuantity = () => setQuantity(quantity + 1)
  const scrollUp = () => thumbnailRef.current?.scrollBy({ top: -100, behavior: "smooth" })
  const scrollDown = () => thumbnailRef.current?.scrollBy({ top: 100, behavior: "smooth" })

  const handleSwipedLeft = () => {
    setActiveImageIndex((prevIndex) => (prevIndex + 1) % productImages.length)
  }
  const handleSwipedRight = () => {
    setActiveImageIndex((prevIndex) => (prevIndex - 1 + productImages.length) % productImages.length)
  }
  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleSwipedLeft,
    onSwipedRight: handleSwipedRight,
    preventScrollOnSwipe: true,
    trackMouse: true,
  })

  const handleWishlistClick = async (e) => {
    e.stopPropagation()

    if (!isLoggedIn || !accessToken) {
      navigate("/login")
      return
    }
    try {
      const payload = {
        product_id: productData._id,
        category_id: productData.category_id?._id || productData.category_id,
      }
      const response = await postWithTokenAPI(accessToken, "/wishlist/add", payload)
      if (response?.statusCode === 200) {
        setIsInWishlist(true)
        dispatch(addToWishlist(productData))
        dispatch(incrementWishlistCount())
        toast.success("Item added to wishlist successfully!")
      } else if (response?.statusCode === 406) {
        setIsInWishlist(false)
        dispatch(removeFromWishlist(productData._id))
        dispatch(decrementWishlistCount())
        toast.success("Item removed from wishlist")
      } else {
        console.warn("Failed to update wishlist:", response)
        toast.error("Failed to update wishlist")
      }
    } catch (error) {
      console.error("Error updating wishlist:", error)
      toast.error("Error updating wishlist")
    }
  }

  const handleAddToCart = async (cartItem) => {
    if (!accessToken) {
      setLoginPopupOpen(true)
      return
    }
    if (!cartItem?._id) return
    if (addingToCart) return
    setAddingToCart(true)
    setError(null)
    try {
      const payload = {
        cart: [
          {
            product_id: cartItem._id,
            quantity: cartItem.quantity > 0 ? cartItem.quantity : 1,
          },
        ],
      }
      const response = await postWithTokenAPI(accessToken, "/cart/add", payload)
      if (response?.statusCode === 200 && response?.message === "Product removed and cart deleted as it became empty") {
        dispatch(setCart([]))
        dispatch(setTotalItems(0))
        dispatch(setTotalPrice(0))
        dispatch(setCartId(null))
        toast.info("Item removed and cart is now empty.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `removed-${cartItem._id}`,
          theme: "light",
        })
      } else if (response?.statusCode === 200 && response.data?.cart) {
        const addedItem = response.data.cart
        dispatch(
          addToCart({
            id: addedItem.product_id,
            price: addedItem.price,
            quantity: addedItem.quantity,
            name: addedItem.name,
            image: addedItem.image,
          }),
        )
        toast.success("Item added to cart successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `cart-${cartItem._id}`,
          theme: "light",
        })
      } else {
        toast.error("Failed to add item to cart.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `error-${cartItem._id}`,
          theme: "light",
        })
      }
    } catch (error) {
      console.error("Add to cart error:", error)
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: `error-${cartItem._id}`,
        theme: "light",
      })
    } finally {
      setAddingToCart(false)
    }
  }

  const closeLoginPopup = () => {
    setLoginPopupOpen(false)
  }

  // Render skeleton when loading
  if (loading) {
    return (
      <div className="product-skeleton-container">
        {/* Product Image Gallery / Carousel Skeleton */}
        <div className="product-skeleton-col-half">
          {/* Mobile View Skeleton */}
          <div className="product-skeleton-desktop-hidden product-skeleton-flex-col product-skeleton-gap-4">
            <div className="product-skeleton-element product-skeleton-h-8 product-skeleton-w-24" /> {/* Back button */}
            <div className="product-skeleton-element product-skeleton-h-300px product-skeleton-rounded-lg" />{" "}
            {/* Main mobile image carousel */}
            <div className="product-skeleton-flex product-skeleton-justify-center product-skeleton-gap-2 product-skeleton-mt-4">
              <div className="product-skeleton-element product-skeleton-h-2 product-skeleton-w-2 product-skeleton-rounded-full" />
              <div className="product-skeleton-element product-skeleton-h-2 product-skeleton-w-2 product-skeleton-rounded-full" />
              <div className="product-skeleton-element product-skeleton-h-2 product-skeleton-w-2 product-skeleton-rounded-full" />
            </div>
          </div>

          {/* Desktop View Skeleton */}
          <div className="product-skeleton-mobile-hidden product-skeleton-flex product-skeleton-gap-4 product-skeleton-w-full">
            <div className="product-skeleton-flex product-skeleton-flex-col product-skeleton-gap-2 product-skeleton-w-20">
              <div className="product-skeleton-element product-skeleton-h-8 product-skeleton-w-8 product-skeleton-rounded-full" />{" "}
              {/* Up arrow */}
              <div className="product-skeleton-flex product-skeleton-flex-col product-skeleton-gap-2 product-skeleton-overflow-hidden">
                <div className="product-skeleton-element product-skeleton-h-16 product-skeleton-w-16 product-skeleton-rounded-md" />
                <div className="product-skeleton-element product-skeleton-h-16 product-skeleton-w-16 product-skeleton-rounded-md" />
                <div className="product-skeleton-element product-skeleton-h-16 product-skeleton-w-16 product-skeleton-rounded-md" />
              </div>
              <div className="product-skeleton-element product-skeleton-h-8 product-skeleton-w-8 product-skeleton-rounded-full" />{" "}
              {/* Down arrow */}
            </div>
            <div className="product-skeleton-element product-skeleton-flex-1 product-skeleton-h-400px product-skeleton-rounded-lg" />{" "}
            {/* Main product image */}
          </div>
        </div>

        {/* Product Details Skeleton */}
        <div className="product-skeleton-col-half">
          <div className="product-skeleton-flex product-skeleton-flex-col product-skeleton-gap-2">
            <div className="product-skeleton-element product-skeleton-h-8 product-skeleton-w-3-4" />{" "}
            {/* Product Title */}
            <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-1-4" /> {/* Seller Name */}
            <div className="product-skeleton-flex product-skeleton-items-center product-skeleton-gap-4">
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-24" />{" "}
              {/* Rating Stars */}
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-20" />{" "}
              {/* Review Count */}
            </div>
          </div>
          <div className="product-skeleton-flex product-skeleton-items-baseline product-skeleton-gap-4">
            <div className="product-skeleton-element product-skeleton-h-6 product-skeleton-w-20" />{" "}
            {/* Original Price */}
            <div className="product-skeleton-element product-skeleton-h-8 product-skeleton-w-24" />{" "}
            {/* Current Price */}
            <div className="product-skeleton-element product-skeleton-h-6 product-skeleton-w-16" />{" "}
            {/* Discount Badge */}
          </div>
          <div className="product-skeleton-element product-skeleton-h-px product-skeleton-w-full" /> {/* Divider */}
          <div className="product-skeleton-flex product-skeleton-flex-col product-skeleton-gap-2">
            <div className="product-skeleton-flex product-skeleton-items-center product-skeleton-gap-2">
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-20" />{" "}
              {/* Share item label */}
              <div className="product-skeleton-flex product-skeleton-gap-2">
                <div className="product-skeleton-element product-skeleton-h-6 product-skeleton-w-6 product-skeleton-rounded-full" />{" "}
                {/* Social Icon */}
                <div className="product-skeleton-element product-skeleton-h-6 product-skeleton-w-6 product-skeleton-rounded-full" />{" "}
                {/* Social Icon */}
                <div className="product-skeleton-element product-skeleton-h-6 product-skeleton-w-6 product-skeleton-rounded-full" />{" "}
                {/* Social Icon */}
                <div className="product-skeleton-element product-skeleton-h-6 product-skeleton-w-6 product-skeleton-rounded-full" />{" "}
                {/* Social Icon */}
              </div>
            </div>
            <div className="product-skeleton-flex product-skeleton-flex-col product-skeleton-gap-2 product-skeleton-mt-2">
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-full" />{" "}
              {/* Description Line 1 */}
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-5-6" />{" "}
              {/* Description Line 2 */}
            </div>
          </div>
          <div className="product-skeleton-element product-skeleton-h-px product-skeleton-w-full" /> {/* Divider */}
          <div className="product-skeleton-flex product-skeleton-items-center product-skeleton-gap-4">
            <div className="product-skeleton-mobile-hidden product-skeleton-flex product-skeleton-gap-2">
              <div className="product-skeleton-element product-skeleton-h-10 product-skeleton-w-10" />{" "}
              {/* Quantity Minus */}
              <div className="product-skeleton-element product-skeleton-h-10 product-skeleton-w-10" />{" "}
              {/* Quantity Number */}
              <div className="product-skeleton-element product-skeleton-h-10 product-skeleton-w-10" />{" "}
              {/* Quantity Plus */}
            </div>
            <div className="product-skeleton-element product-skeleton-h-10 product-skeleton-w-32" />{" "}
            {/* Add to Cart Button */}
            <div className="product-skeleton-element product-skeleton-h-10 product-skeleton-w-10 product-skeleton-rounded-full" />{" "}
            {/* Wishlist Button */}
          </div>
          <div className="product-skeleton-flex product-skeleton-flex-col product-skeleton-gap-2">
            <div className="product-skeleton-flex product-skeleton-gap-2">
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-16" />{" "}
              {/* Category Label */}
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-24" />{" "}
              {/* Category Name */}
            </div>
            <div className="product-skeleton-flex product-skeleton-gap-2">
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-10" /> {/* Tag Label */}
              <div className="product-skeleton-element product-skeleton-h-4 product-skeleton-w-20" /> {/* Tag Name */}
            </div>
          </div>
        </div>

        {/* Product Details and Related Products Placeholders */}
        <div className="product-skeleton-w-full product-skeleton-mt-8">
          <div className="product-skeleton-element product-skeleton-h-48 product-skeleton-rounded-lg product-skeleton-mb-8" />{" "}
          {/* Product Details section */}
          <div className="product-skeleton-element product-skeleton-h-48 product-skeleton-rounded-lg" />{" "}
          {/* Related Products section */}
        </div>
      </div>
    )
  }

  if (error) return <div className="error-message">Error: {error}</div>
  if (!productData) return <div className="error-message">Product not found</div>

  const starRatingConfig = {
    size: 20,
    value: productData.average_rating || 0,
    edit: false,
    activeColor: "#ffd700",
    color: "#d4d4d4",
    isHalf: true,
    count: 5,
    a11y: true,
    onChange: () => {},
    classNames: {
      container: "star-rating-container",
      star: "star-rating-star",
    },
  }

  return (
    <>
      <ToastContainer />
      <Helmet>
        <title>{productData.name ? `${productData.name}'s Product` : "Product"}</title>
        <meta name="description" content="Specific Product page" />
      </Helmet>
      {isLoginPopupOpen && <LoginPopup onClose={closeLoginPopup} />}
      <div className="product-containers">
        {/* Product Image Gallery / Carousel */}
        {isMobileView ? (
          <div className="mobile-image-carousel">
            <div className="button-back-mobile" onClick={() => navigate("/shop")}>
              <FaArrowLeft className="back-icon" />
              <button className="back-text">back</button>
            </div>
            <div
              {...swipeHandlers}
              className="carousel-images"
              style={{ transform: `translateX(-${activeImageIndex * 100}%)` }}
            >
              {productImages.map((image, index) => (
                <img
                  key={index}
                  src={image || "/placeholder.svg"}
                  className="carousel-image-item"
                  alt={`Product view ${index + 1}`}
                />
              ))}
            </div>
            {productImages.length > 1 && (
              <div className="carousel-dots">
                {productImages.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${index === activeImageIndex ? "active" : ""}`}
                    onClick={() => setActiveImageIndex(index)}
                  ></span>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="product-image-container">
            <div className="side-image">
              <button className="nav-arrow up" onClick={scrollUp}>
                <img src={up || "/placeholder.svg"} alt="Scroll up" />
              </button>
              <div className="show-image" ref={thumbnailRef}>
                {productImages.map((image, index) => (
                  <img
                    key={index}
                    src={image || "/placeholder.svg"}
                    className={`select-image ${index === activeImageIndex ? "active" : ""}`}
                    onClick={() => setActiveImageIndex(index)}
                    alt={`Thumbnail ${index + 1}`}
                  />
                ))}
              </div>
              <button className="nav-arrow down" onClick={scrollDown}>
                <img src={down || "/placeholder.svg"} alt="Scroll down" />
              </button>
            </div>
            <div className="main-product-container">
              <img
                src={productImages[activeImageIndex] || "/placeholder.svg"}
                className="main-product"
                alt="Main product view"
              />
            </div>
          </div>
        )}
        {/* Product Details */}
        <div className="product-detail-box">
          <div className="product-header">
            <div className="product-title-row">
              <h1 className="product-titles">{productData.name}</h1>
              {isMobileView && (
                <button
                  className={`wish-btn mobile-wish-btn ${isInWishlist ? "wishlist-active" : ""}`}
                  onClick={handleWishlistClick}
                  aria-label="Toggle Wishlist"
                >
                  {isInWishlist ? (
                    <FaHeart style={{ color: "#CC0000" }} />
                  ) : (
                    <FaRegHeart style={{ color: "#1a1a1a" }} />
                  )}
                </button>
              )}
            </div>
            <span className="ff-poppins fs-12" style={{ color: "#CC0000" }}>
              {sellerName}
            </span>
            <div className="rating-sku">
              <div className="rating">
                <ReactStars {...starRatingConfig} key={`stars-${productData.average_rating}`} />
              </div>
              <span className="review-count">{productData.average_rating || 0} rating</span>
            </div>
          </div>
          <div className="price-section">
            <div className="price-row-product">
              {productData.original_price && (
                <span className="original-price">Ksh {productData.original_price.toFixed(2)}</span>
              )}
              <span className="current-price">Ksh {productData.discount_price.toFixed(2)}</span>
              {productData.original_price && (
                <div className="discount-badge">
                  {Math.round(100 - (productData.discount_price / productData.original_price) * 100)}% Off
                </div>
              )}
            </div>
          </div>
          <div className="dividers"></div>
          <div className="brand-section">
            <div className="brand-header">
              <div className="share-section-product">
                <span>Share item:</span>
                <div className="social-icon-product">
                  <a href="https://www.facebook.com/" aria-label="Facebook">
                    <FaFacebookF />
                  </a>
                  <a href="https://x.com/?lang=en" aria-label="Twitter">
                    <FaTwitter />
                  </a>
                  <a href="https://in.pinterest.com/" aria-label="Pinterest">
                    <FaPinterestP />
                  </a>
                  <a href="https://www.instagram.com/" aria-label="Instagram">
                    <FaInstagram />
                  </a>
                </div>
              </div>
            </div>
            <p className="brand-description">
              <div className="brand-description" dangerouslySetInnerHTML={{ __html: cleanHTML }} />
            </p>
          </div>
          <div className="dividers"></div>
          <div className="cta-section">
            {!isMobileView && (
              <div className="quantity-selectors">
                <button className="quantity-btn minus" onClick={decreaseQuantity}>
                  -
                </button>
                <span className="quantity">{quantity}</span>
                <button className="quantity-btn plus" onClick={increaseQuantity}>
                  +
                </button>
              </div>
            )}
            <button
              className="add-to-cart"
              onClick={() => handleAddToCart({ ...productData, quantity: isMobileView ? 1 : quantity })}
            >
              Add to Cart
              <img src={cartIcon || "/placeholder.svg"} alt="cart" />
            </button>

            <button className={`wish-btn ${isInWishlist ? "wishlist-active" : ""}`} onClick={handleWishlistClick}>
              {isInWishlist ? (
                <FaHeart style={{ color: "#CC0000", fontSize: "16px" }} />
              ) : (
                <FaRegHeart style={{ color: "#1a1a1a", fontSize: "16px" }} />
              )}
            </button>
          </div>
          <div className="category-tags">
            <div className="category">
              <span>Category:</span>
              <span>{productData.category_id.category_name || "General"}</span>
            </div>
            <div className="tags">
              <span>Tag:</span>
              {(productData.tag || ["Healthy"]).map((tags, i) => (
                <span key={i}>{tags}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ProductDetails productData={productData} />
      <RelatedProductsmy />
    </>
  )
}

export default ProductCard

